import { render, staticRenderFns } from "./ImagesMarks.vue?vue&type=template&id=3c819840&scoped=true&"
import script from "./ImagesMarks.vue?vue&type=script&lang=js&"
export * from "./ImagesMarks.vue?vue&type=script&lang=js&"
import style0 from "./ImagesMarks.vue?vue&type=style&index=0&id=3c819840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c819840",
  null
  
)

export default component.exports